"use client";

import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";


interface LoggerContextType {
  logger: any;
  setLogger: (configurator: any) => void;
}

const LoggerContext = createContext<LoggerContextType | undefined>(undefined);

const LoggerContextProvider = ({ children }: { children: ReactNode }) => {
  const [logger, setLogger] = useState<any>(null);

  const value = useMemo(
    () => ({
        logger,
      setLogger
    }),
    [
        logger,
      setLogger
    ],
  );

  return (
    <LoggerContext.Provider value={value}>
      {children}
    </LoggerContext.Provider>
  );
};

const useLoggerContext = () => {
  const context = useContext(LoggerContext);
  if (!context) {
    throw new Error(
      "useLoggerContext must be used within a parent component",
    );
  }
  return context;
};

export { LoggerContextProvider, useLoggerContext };
